<template>
    <div class="boards">
      
      <!-- <div class="columns">
        <div class="column is-full">
        <b-breadcrumb
        size="is-small"
            separator="has-arrow-separator"
        >
            <b-breadcrumb-item href="/">Home</b-breadcrumb-item>
            <b-breadcrumb-item href="/documentation">Docs</b-breadcrumb-item>
            <b-breadcrumb-item href="/documentation/breadcrumb" active>Breadcrumb</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div> -->
      
      <div class="columns">
        <div class="column is-one-fifth">



          <b-button @click="isModalProjectCreateOpen = true" expanded class="is-info">
                Create my own AI
          </b-button>
          <b-button expanded tag="router-link" class="is-ghost" :to="`/explore`">
            Explore pre-build AI
          </b-button>
      
          
          
          <!-- <div class="buttons">

<b-button @click="isModalDatasetCreateOpen = true" class="is-info">
Create a Dataset
</b-button>

<b-button @click="isModalModelCreateOpen = true" class="is-info">
Create a Model
</b-button>

</div> -->

<hr>




  <div class="block" v-if="currentUser && currentUser.plan.name != 'Pro'">
    <h4 class="title is-6">Current plan is Starter</h4>
    <h4 class="subtitle is-6">Upgrade to PRO plan for access to AI templates, datasets, models, and more.</h4>
  </div>
  <div class="block" v-if="currentUser">
    <h4 class="title is-6">Monthly usage</h4>
    <h4 class="subtitle is-6">Restarts every month
    </h4>
      <b-progress type="is-success" :max="currentUser.plan.predictionsLimit" :value="currentUser.predictionsTotal" show-value>
          Predictions {{ currentUser.predictionsTotal }} out of {{ currentUser.plan.predictionsLimit || currentUser.plan.predictions}}
      </b-progress>
      <!-- <b-progress type="is-success" :max="currentUser.plan.datasetRowsLimit" :value="currentUser.datasetRowsTotal" show-value>
          <span class="is-pulled-right">Dataset rows {{ currentUser.datasetRowsTotal }} out of {{ currentUser.plan.datasetRowsLimit }}</span>
      </b-progress>
      <b-progress type="is-success" :max="currentUser.plan.modelTrainingsLimit" :value="currentUser.modelTrainingsTotal" show-value>
          Trainings {{ currentUser.modelTrainingsTotal }} out of {{ currentUser.plan.modelTrainingsLimit }}
      </b-progress> -->
      
  </div>

  </div>

  
  <div class="column">
    
      
      <div id="models" v-if="projects && projects.length > 0">
        <h1 class="title is-4">
            Projects
        </h1>
        <div class="boards-grid">

        <router-link class="card board" :to="(!model.datasetId)?`/projects/${model.id}/uploads`:(['classification', 'classify'].includes(model.type)?`/projects/${model.id}/train`:`/projects/${model.id}/uploads`)" 
          v-for="(model, index) in projects"
          :key="index">
          
          <div class="card-content info" type="is-info">
            <div class="content">
              <div class="media-content">
                <!-- <b-dropdown class="is-pulled-right" :triggers="['hover']" aria-role="list">
                    <template #trigger>
                      &#10247;
                    </template>


                    <b-dropdown-item aria-role="listitem">Delete</b-dropdown-item>
                    <b-dropdown-item aria-role="listitem">Clone</b-dropdown-item>
                </b-dropdown> -->
                <p class="name title is-5">
                  {{model.name}}
                </p>
                <p class="description is-6">
                  <span v-if="model.description != undefined">
                    {{ model.description }}
                  </span>
                  <span v-else>
                    &nbsp;
                  </span>
                </p>
              </div>
            </div>

            <div class="bottom-left">
                
                <b-tag type="is-info" v-if="['loading', 'training', 'labeling'].includes(projectStatus(model))">
                  {{ projectStatus(model) }}
                </b-tag>
                <b-tag type="is-warning" v-else-if="projectStatus(model).includes('warning')">
                  {{ projectStatus(model) }}
                </b-tag>
                <b-tag type="is-success" v-else-if="projectStatus(model).includes('online')">
                  {{ projectStatus(model) }}
                </b-tag>
                <b-tag type="is-light" v-else-if="projectStatus(model).includes('draft')">
                  {{ projectStatus(model) }}
                </b-tag>
            </div>
            <div class="bottom-right">
                <!-- <b-tag type="is-secondary" v-if="model.model_metrics != undefined && 'accuracy' in model.model_metrics">
                  <b-tooltip label="Model accuracy"
                      position="is-bottom"
                      type="is-light">
                      {{  (model.model_metrics["accuracy"]*100).toFixed(0) }}/100
                  </b-tooltip>
                </b-tag>
                <b-tag type="is-secondary" v-else-if="projectDocuments != undefined">
                  <b-tooltip label="Data points to label"
                      position="is-bottom"
                      type="is-light">
                      {{  (model.model_metrics["accuracy"]*100).toFixed(0) }}/100
                  </b-tooltip>
                </b-tag> -->
                <b-tag type="is-secondary">
                  {{ model.type }}
                </b-tag>
            </div>
          </div>
        </router-link>

      </div>
    </div>
    <br><br>
    <div id="models" v-if="models && models.length > 0">
        <h1 class="title is-4">
            Models
        </h1>
        <div class="boards-grid">

        <router-link class="card board" :to="(!model.datasetId)?`/projects/${model.id}/uploads`:(['classification', 'classify'].includes(model.type)?`/projects/${model.id}/train`:`/projects/${model.id}/uploads`)" 
          v-for="(model, index) in models"
          :key="index">
          
          <div class="card-content info" type="is-info">
            <div class="content">
              <div class="media-content">
                <!-- <b-dropdown class="is-pulled-right" :triggers="['hover']" aria-role="list">
                    <template #trigger>
                      &#10247;
                    </template>


                    <b-dropdown-item aria-role="listitem">Delete</b-dropdown-item>
                    <b-dropdown-item aria-role="listitem">Clone</b-dropdown-item>
                </b-dropdown> -->
                <p class="name title is-5">
                  {{model.name}}
                </p>
                <p class="description is-6">
                  <span v-if="model.description != undefined">
                    {{ model.description }}
                  </span>
                  <span v-else>
                    &nbsp;
                  </span>
                </p>
              </div>
            </div>

            <div class="bottom-left">
                
                <b-tag type="is-info" v-if="['loading', 'training', 'labeling'].includes(projectStatus(model))">
                  {{ projectStatus(model) }}
                </b-tag>
                <b-tag type="is-warning" v-else-if="projectStatus(model).includes('warning')">
                  {{ projectStatus(model) }}
                </b-tag>
                <b-tag type="is-success" v-else-if="projectStatus(model).includes('online')">
                  {{ projectStatus(model) }}
                </b-tag>
                <b-tag type="is-light" v-else-if="projectStatus(model).includes('draft')">
                  {{ projectStatus(model) }}
                </b-tag>
            </div>
            <div class="bottom-right">
                <!-- <b-tag type="is-secondary" v-if="model.model_metrics != undefined && 'accuracy' in model.model_metrics">
                  <b-tooltip label="Model accuracy"
                      position="is-bottom"
                      type="is-light">
                      {{  (model.model_metrics["accuracy"]*100).toFixed(0) }}/100
                  </b-tooltip>
                </b-tag>
                <b-tag type="is-secondary" v-else-if="projectDocuments != undefined">
                  <b-tooltip label="Data points to label"
                      position="is-bottom"
                      type="is-light">
                      {{  (model.model_metrics["accuracy"]*100).toFixed(0) }}/100
                  </b-tooltip>
                </b-tag> -->
                <b-tag type="is-secondary">
                  {{ model.type }}
                </b-tag>
            </div>
          </div>
        </router-link>

      </div>
    </div>
    <div v-else>
      <p>
        <h4 class="subtitle is-5">
          Let's create your first AI in 2 minutes.
        </h4>
      </p>
      
      <b-image
            :src="require('@/images/project-setup-steps.svg')"
            style="width:50em"
            
        ></b-image>

      <figure class="image">
        
              
              <p>
                <a href="https://discord.gg/NdWMd8mrS5" target="_blank" >💬&nbsp;Join our community&nbsp;<small><small>(Discord server)</small></small></a>
              </p>
              <p>
                🎥 Watch the intro video to see how to create your custom AI solution
              </p><br>
              
              <iframe width="100%" height="400em" src="https://www.youtube.com/embed/0hVmyiWJfz8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              
              <hr>
      </figure>

    </div>
  

</div>
</div>
  
    <!-- MODALS -->
      <b-modal
          v-model="isModalProjectCreateOpen"
          has-modal-card
          trap-focus
          :destroy-on-hide="false"
          aria-role="dialog"
          aria-label="Project"
          aria-modal  
          can-cancel
          full-screen
          scroll="keep">
          <template #default="props">
              <modal-project @close="props.close"></modal-project>
          </template>
      </b-modal>
    </div>
    
  </template>
  
  <script>
  import { SidebarMenu } from 'vue-sidebar-menu'
  import 'vue-stepper-component'
  import ModalModel from '@/components/ModelCreate.vue'
  import ModalDataset from '@/components/DatasetCreate.vue'
  import ModalGetStarted from '@/components/GetStarted.vue'
  import ModalProject from '@/components/ProjectCreate.vue'

  export default {
    props: ["show"],
    name: "Explore",
    data() {
      return {
        isStepsClickable: true,
        isModalProjectCreateOpen: (this.$route.path.includes('show')?true:false),
        isModalModelCreateOpen: false,
        isModalDatasetCreateOpen: false,
        isModalGetStartedOpen: false,
        showTemplates: true,
        menu: [
                    {
                        header: true,
                        title: 'Main Navigation',
                        hiddenOnCollapse: true
                    },
                    {
                        href: '/',
                        title: 'Dashboard',
                        icon: 'fa fa-user'
                    },
                    {
                        href: '/charts',
                        title: 'Charts',
                        icon: 'fa fa-chart-area',
                        child: [
                            {
                                href: '/charts/sublink',
                                title: 'Sub Link'
                            }
                        ]
                    }
                ],
        items: [
          {
            name: "Get started", id: "get-started"
          },
        ],
        inputTaskList: [{id: 'text', name: 'Text'}, {id: 'pdf', name: 'PDF'}],
        inputTask: 'text',
        modelType: 'classification',
        modelTypeList: [
            {id: 'classification', name: 'Classification'}, 
            {id: 'extraction', name: 'Extraction'}, 
            {id: 'summarization', name: 'Summarization'},
            {id: 'generation', name: 'Generation'}
        ],
      };
    },
    components: {
      "modal-get-started": ModalGetStarted,
      "modal-model": ModalModel,
      "modal-dataset": ModalDataset,
      "modal-project": ModalProject,
      SidebarMenu
    },
    computed: {
      projects() {
        return [...this.$store.state.projects]
      },
      models() {
        return [...this.$store.state.models]
      },
      datasets() {
        return [...this.$store.state.datasets]
      },
      projectsPublic() {
        return [...this.$store.state.projectsPublic]
      },
      currentUser() {
            return this.$store.state.currentUser;
        },
    },
    methods:{
      projectStatus(project){
        
        if( "state" in project){
          if("train" in project.state && "status" in project.state.train){
            let status = project.state.train.status

            if (status != 'running' && status != 'triggering' && status != 'complete'){
              return 'model: warning'
            } else if(status == 'running' && status == 'triggering'){
              return 'model: training'
            } else if (status == 'complete') {
              return 'model: online'
            }
          } else if ("upload" in project.state){
            let status = project.state.upload.status

            if (status != 'running' && status != 'complete'){
              return 'dataset: warning'
            } else if(status == 'running'){
              return 'dataset: loading'
            } else if (status == 'complete') {
              return 'dataset: annotating'
            }
          }
        }

        return ''
      },
    },
    created() {
      this.$store.dispatch("currentUser");
      this.$store.dispatch("retrieveAllProjects");
      this.$store.dispatch("retrieveAllPublicProjects");
      this.$store.dispatch("retrieveAllModels");
      this.$store.dispatch("retrieveAllDatasets");
    },
        
      
  };
  </script>
  
  <style lang="scss" scoped>
.boards-grid-small {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 16px;
}

  .boards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 16px;
  
    .board {
      cursor: pointer;
      border: solid 1px #e6e4e4;
      border-radius: 4px;
      min-height: 10em;
  
      &:hover {
        background: #fafafa;
      }
  
      .info {
        padding: 16px;
        display:flex;
        flex-direction:column;
        justify-content:space-between
  
        .name {
          display: block;
          margin-bottom: 8px;
          text-transform: capitalize;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
  
        .description {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          margin: 0;
          margin-bottom: 8px;
          overflow: hidden;
        }

        .bottom-left {
          position: absolute;
          margin-top: auto;
          margin-bottom: 0.8em;
          bottom: 0;
          left: 0.8em;
        }
        .bottom-right {
          position: absolute;
          margin-top: auto;
          margin-bottom: 0.8em;
          bottom: 0;
          right: 0.8em;
        }
      }
    }
  }
  </style>